import SuppositoryTab from "../components/tabs/SuppositoryTab";
import TrocheTab from "../components/tabs/TrocheTab";
import CapsuleTab from '../components/tabs/CapsuleTab';
import TreatTab from '../components/tabs/TreatTab';
import CreamTab from '../components/tabs/CreamTab';
import BiestTab from "../components/tabs/BiestTab";

export default [
  {
    id: "suppository",
    label: "Suppositories",
    Tab: SuppositoryTab,
  },
  {
    id: "troche",
    label: "Troches",
    Tab: TrocheTab,
  },
  {
    id: "capsule",
    label: "Capsules",
    Tab: CapsuleTab,
  },
  {
    id: "treat",
    label: "Treats",
    Tab: TreatTab,
  },
  {
    id: "biest",
    label: "Bi-est",
    Tab: BiestTab,
  },
  {
    id: "cream",
    label: "Cream",
    Tab: CreamTab,
  },
  
];
